module.exports = __webpack_public_path__ + "assets/img/svg/common/pin-primary.svg?v=1745575385087";